// extracted by mini-css-extract-plugin
module.exports = {"sslowerD":"SSCardMain_sslowerD__3IFAB","sscardMainDiv":"SSCardMain_sscardMainDiv__2DDne","ssImgC":"SSCardMain_ssImgC__34WRs","ssparaDesc":"SSCardMain_ssparaDesc__UrHs7"};